import React from "react";
import { Loader2, Plus } from "lucide-react";
import TooltipWrapper from "ui/TooltipWrapper";

interface AddButtonProps {
    tooltipTitle: string;
    buttonText?: string;
    onClick: () => void;
    className?: string;
    noPlus?: boolean;
    /**
     * When true, disables the button and shows a spinner in place of the label.
     * Useful for submit actions that should not be double-clicked.
     */
    isLoading?: boolean;
}

const AddButton: React.FC<AddButtonProps> = ({
    tooltipTitle,
    buttonText,
    onClick,
    className = "",
    noPlus = false,
    isLoading = false,
}) => {
    return (
        <TooltipWrapper title={tooltipTitle} arrow>
            <button
                className={`add-button ${className} max-w-[748px]`}
                onClick={onClick}
                disabled={isLoading}
                aria-busy={isLoading}
            >
                {!noPlus && !isLoading && (
                    <Plus className="dark:stroke-eoe-dark-icon-stroke dark:hover:stroke-eoe-dark-icon-stroke-hover" />
                )}
                {buttonText && (
                    <>
                        {isLoading ? (
                            <Loader2 className="eoe-add-button__loader size-6 animate-spin" aria-label="Loading" />
                        ) : (
                            <span>{buttonText}</span>
                        )}
                    </>
                )}
            </button>
        </TooltipWrapper>
    );
};

export default AddButton;